import "./AppEmployeeRecordPTOAdjustments.css";
import { PaidTimeOffAdjustment, PaidTimeOffPolicy, formatDateDayMonDDYYYY } from "winslow-core";

type AppEmployeeRecordPTOAdjustmentsProps = {
    paidTimeOffAdjustments: PaidTimeOffAdjustment[] | undefined;
    paidTimeOffPolicies: PaidTimeOffPolicy[] | undefined;
};

export const AppEmployeeRecordPTOAdjustments = ({ 
    paidTimeOffAdjustments, 
    paidTimeOffPolicies 
}: AppEmployeeRecordPTOAdjustmentsProps) => {
    if (!paidTimeOffAdjustments || paidTimeOffAdjustments.length < 1) {
        return (
            <div className="app-employee-record-pto-adjustments-empty">
                No PTO Adjustments
            </div>
        );
    }

    if (!paidTimeOffPolicies) {
        return (
            <div className="app-employee-record-pto-adjustments-empty">
                Loading policies...
            </div>
        );
    }

    return (
        <div className="app-employee-record-pto-adjustments">
            {paidTimeOffAdjustments.map((adjustment: PaidTimeOffAdjustment) => {
                const policy = paidTimeOffPolicies.find((policy: PaidTimeOffPolicy) => {
                    return policy.id === adjustment.paidTimeOffPolicyId;
                });

                if (!policy) {
                    return null;
                }

                return (
                    <div key={adjustment.id} className="app-employee-record-pto-adjustment">
                        <div className="app-employee-record-pto-adjustment-policy">
                            <strong>Policy:</strong> {policy.name}
                        </div>
                        <div className="app-employee-record-pto-adjustment-date">
                            <strong>Adjustment Date:</strong> {formatDateDayMonDDYYYY(new Date(adjustment.createdAt))}
                        </div>
                        <div className="app-employee-record-pto-adjustment-hours">
                            <strong>Adjusted Hours:</strong> {adjustment.isAddition ? "" : "-"}{Math.floor(adjustment.adjustedHours/8)} Days
                        </div>
                        {adjustment.noteVisible && (
                            <div className="app-employee-record-pto-adjustment-note">
                                <strong>Note:</strong>
                                <pre>{adjustment.noteVisible}</pre>
                            </div>
                        )}
                        {adjustment.noteAdmin && (
                            <div className="app-employee-record-pto-adjustment-note-admin">
                                <strong>Admin Note:</strong>
                                <pre>{adjustment.noteAdmin}</pre>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

